import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from 'swiper';
import { fetchSaloons } from '../../../../../redux/action/saloons/saloons';
import MainLoading from '../../../../../utils/MainLoading';
import DashboardTitle from '../../../../dashboardTitle/DashboardTitle';
import '../../style.scss'
SwiperCore.use([Pagination]);

const DashDeveloperHalls = () => {
  const saloons = useSelector(state => state.saloons)
  const dispatch = useDispatch()
  const {t} = useTranslation();

  useEffect(() => {
    if(!saloons.saloons.length) {
      dispatch(fetchSaloons())
    }
  }, [])

    return (
      <div className='mt-2 mb-5 dash_slider_container'>
        <DashboardTitle title={t("dashboard_nav_saloons")} link={`/dashboard/saloons`} />
          {saloons.loading ? 
            <MainLoading /> 
          :
            saloons.saloons.length ? 
            <Swiper 
              spaceBetween={10} 
              pagination={{ "clickable": true }}
              breakpoints={{
                640: {
                  width: 640,
                  slidesPerView: 1,
                },
                900: {
                  width: 900,
                  slidesPerView: 2,
                },
                990: {
                  width: 990,
                  slidesPerView: 3,
                },
              }}
              className="dashboardSwiper">
              {saloons.saloons.map(saloon => (
                <SwiperSlide key={saloon.id}>    
                  <div key={saloon.id}>
                    <Link to={`/dashboard/saloon/${saloon.id}`} className="dash_slider_item">
                      <h1> {saloon.name}</h1>
                      <h6> {saloon.users_count} {t("company")}</h6>
                    </Link>
                  </div>
                </SwiperSlide>
                ))}
            </Swiper>
            : <p className='text-center'>{t("hall has not been built yet")}</p>
          }
      </div>
    );
}

export default DashDeveloperHalls
